'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Checkbox(_ref) {
  var id = _ref.id,
      checked = _ref.checked,
      text = _ref.text,
      count = _ref.count,
      _onChange = _ref.onChange;

  return _react2.default.createElement(
    'label',
    { htmlFor: 'checkbox-' + id, className: checked ? 'checked' : parseInt(count, 10) === 0 ? 'uncheckable' : '' },
    _react2.default.createElement('span', { className: 'check' }),
    _react2.default.createElement('input', {
      id: 'checkbox-' + id,
      className: 'tclick',
      type: 'checkbox',
      checked: checked ? 'checked' : '',
      onChange: function onChange() {
        _onChange(id, !checked);
      },
      disabled: count !== undefined ? !count && !checked : false
    }),
    text,
    '\xA0',
    count !== undefined ? _react2.default.createElement(
      'small',
      null,
      '(',
      count,
      ')'
    ) : null
  );
} // Checkbox

Checkbox.propTypes = {
  id: _react.PropTypes.string.isRequired,
  checked: _react.PropTypes.bool,
  text: _react.PropTypes.string.isRequired,
  count: _react.PropTypes.number,
  onChange: _react.PropTypes.func.isRequired
};

exports.default = Checkbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkbox.js
// module id = 1194
// module chunks = 0